class TruncateText extends HTMLElement {
  selectors = {
    text: '[data-truncate-text-el="text"]',
    cta: '[data-truncate-text-el="cta"]',
  }

  els = {
    text: this.querySelector(this.selectors.text),
    cta: this.querySelector(this.selectors.cta),
  }

  connectedCallback () {
    const maxLength = 14

    if (!this.els.text || !this.els.cta) {
      this.show()
      return
    }

    if (this.els.text.textContent.split(' ').length > maxLength) {
      this.truncateText(this.els.text, this.els.text.textContent, maxLength)
      this.setupEventListeners()
    }
    this.show()
  }

  setupEventListeners () {
    this.els.cta.addEventListener('click', this.handleClick.bind(this))
  }

  handleClick () {
    const extraText = document.querySelector('[data-truncate-text-el="hidden-text"]')

    if (extraText) {
      this.els.text.textContent = this.els.text.textContent.replace('...more', ' ')
      extraText.classList.remove('hidden')

      window.dataLayer.push({
        event: 'plp_expand_header_text',
      })
    }
  }

  show () {
    this.classList.remove('hidden')
  }

  truncateText (el, text, maxLength) {
    const words = text.split(' ')
    const truncatedContent = words.slice(0, maxLength).join(' ')
    const remainingContent = words.slice(maxLength).join(' ')

    el.textContent = truncatedContent

    el.insertAdjacentHTML('beforeend', '<span data-ga-el="plp-description-more">...more</span>')

    el.insertAdjacentHTML('beforeend', `<span data-truncate-text-el="hidden-text" class="truncate-text__more-text hidden">${remainingContent}</span>`)
  }
}

customElements.define('truncate-text', TruncateText)
